module.exports = __webpack_public_path__ + "static/media/Css3.7415a70a.svg";